import { Injectable } from '@angular/core';
import { escolaBehavior } from '../../models/escola.interface';
import { permissaoBehavior } from '../../models/role.enum';
import { BehaviorSubject } from 'rxjs';
import { alunoSelecionado } from '../../private/admin/pages/alunos/alunos.service';

@Injectable({
  providedIn: 'root',
})
export class StorageServiceService {

  salvarEscolaSeNaoExistir(escola: escolaBehavior) {
    if (sessionStorage.getItem('escolaSelecionada')) {
      sessionStorage.removeItem('escolaSelecionada');
    }
    sessionStorage.setItem('escolaSelecionada', JSON.stringify(escola));

  }

  salvarAlunoSeNaoExistir(aluno: alunoSelecionado) {
    if (sessionStorage.getItem('alunoSelecionado')) {
      sessionStorage.removeItem('alunoSelecionado');
    }
    sessionStorage.setItem('alunoSelecionado', JSON.stringify(aluno));

  }

  salvarPermissaoSeNaoExistir(permissao: permissaoBehavior) {
    if (sessionStorage.getItem('permissaoSelecionada')) {
      sessionStorage.removeItem('permissaoSelecionada');
    }
    sessionStorage.setItem('permissaoSelecionada', JSON.stringify(permissao));

  }

  obterEscola(): escolaBehavior | undefined {
    const escola = sessionStorage.getItem('escolaSelecionada');
    return escola ? JSON.parse(escola) : undefined;
  }

  obterPermissao(): permissaoBehavior | undefined {
    const permissao = sessionStorage.getItem('permissaoSelecionada');
    return permissao ? JSON.parse(permissao) : undefined;
  }

  obterAluno(): alunoSelecionado | undefined {
    const aluno = sessionStorage.getItem('alunoSelecionado');
    return aluno ? JSON.parse(aluno) : undefined;
  }

  limpar() {
    sessionStorage.removeItem('escolaSelecionada');
    sessionStorage.removeItem('permissaoSelecionada');
    sessionStorage.removeItem('alunoSelecionado');
  }
}
